export class DefaultResult {
    public code: number | null;
    public errors: string[];
    public get hasErrors(): boolean {
        return this.errors != null && Array.isArray(this.errors) && this.errors.length > 0;
    }

    constructor(code: number | null, ...errors: string[]) {
        this.code = code;
        this.errors = errors[0] == undefined || errors[0] == null ? [] : errors;
    }
}
export class Result<T> {
    public code: number | null;
    public value: T;
    public errors: string[];
    public get hasErrors(): boolean {
        return this.errors != null && Array.isArray(this.errors) && this.errors.length > 0;
    }

    constructor(code: number | null, value: T, ...errors: string[]) {
        this.code = code;
        this.value = value;
        this.errors = errors[0] == undefined || errors[0] == null ? [] : errors;
    }
}